package io.horion.cv.pages.navigation

sealed class Screen(val title: String, val path: String) {
    object Home: Screen(title = "home", path = "/")
    object CV: Screen(title = "CV", path = "/choose-cv")
    object Motivation: Screen(title = "Lettre de motivation", path = "/motivation")
    object Price: Screen(title = "Prix", path = "/price")
    object Job: Screen(title = "Offres d'emploi", path = "/job")
    object Faq: Screen(title = "FAQ", path = "/faq")

    object Payment: Screen(title = "Payment", path = "/payment")
    object PaymentProcessing: Screen(title = "Payment Processing", path = "/payment-processing")
    object PaymentConfirmation: Screen(title = "Payment Confirmation", path = "/confirmation")
    object PaymentSuccess: Screen(title = "Payment Success", path = "/payment-success")

    object Dashboard: Screen(title = "Tableau de bord", path = "/dashboard/tableau-de-bord")
    object CvDashboard: Screen(title = "Curriculum vitae", path = "/dashboard/cv")
    object LetterDashboard: Screen(title = "Lettres de motivation", path = "/dashboard/Lettres")
    object JobDashboard: Screen(title = "Offres d'emploi", path = "/dashboard/offres-emploi")
    object CandidaturesDashboard: Screen(title = "Offres d'emploi", path = "/dashboard/canditatures")
    object UpdateCv: Screen(title = "Modifier CV", path = "/dashboard/update-cv")
    object UpdateLetter: Screen(title = "Modifier lettre", path = "/dashboard/update-letter")
}

val links: Map<String, String> = mapOf(
    Screen.CV.title to Screen.CV.path,
    Screen.Motivation.title to Screen.Motivation.path,
//    Screen.Job.title to Screen.Job.path,
//    Screen.Price.title to Screen.Price.path,
    Screen.Faq.title to Screen.Faq.path,
)
val dashboardLinks: Map<String, String> = mapOf(
//    Screen.Dashboard.title to Screen.Dashboard.path,
    Screen.CvDashboard.title to Screen.CvDashboard.path,
    Screen.LetterDashboard.title to Screen.LetterDashboard.path,
    Screen.JobDashboard.title to Screen.JobDashboard.path,
//    Screen.Home.title to Screen.Home.path,
//    "Offres d'emploi" to "/dashboard/offres-emploi",
)